<!-- eslint-disable @angular-eslint/template/elements-content -->
<!-- eslint-disable @angular-eslint/template/cyclomatic-complexity -->
@if (showLoadingState()) {
  <mwe-basic-card [hasBackground]="false">
    <dotlottie-player
      class="mx-auto mb-5"
      aria-hidden="true"
      autoplay
      loop
      playMode="normal"
      id="dot-lottie-confirmation-loading"
      src="/assets/loading-animation/windmills.lottie"
      playerId="dot-lottie-confirmation-loading"
      style="max-width: 273px; display: block"
    ></dotlottie-player>
    <h1 data-test="mwe-confirmation-view-header-loading" class="h5 text-center" [translate]="workInProgressMsgKey()"></h1>
    @if (workInProgressSubtextKey()) {
      <span class="text--large text-center d-block" [translate]="workInProgressSubtextKey()"></span>
    }
  </mwe-basic-card>
}
@if (showErrorState()) {
  @if (errorTitleKey()) {
    <div class="mb-5" data-test="mwe-confirmation-view-error">
      <mwe-inline-notification
        type="danger"
        [titleKey]="errorTitleKey()"
        [messageKey]="retryAllowed() && errorMsgRetryKey() ? errorMsgRetryKey() : errorMsgKey()"
        [placeholderMap]="alertPlaceholders()"
        [ctaLabelKey]="ctaLabelKey()"
        (onCTAClick)="handleCTAClick()"
      ></mwe-inline-notification>
    </div>
  }
  @if (!isFirstStepError() || !shouldHideKeysIfFirstStepIsError()) {
    <mwe-basic-card [hasBackground]="false">
      <ng-container *ngTemplateOutlet="stepsList; context: { steps: steps() }" />
    </mwe-basic-card>
  }
}
@if (showSuccessState()) {
  @if (infoSteps()?.length) {
    <mwe-basic-card data-test="mwe-confirmation-view-success-info">
      <mwe-next-steps [stepsTitle]="infoTitleKey()" [infoSteps]="infoSteps()" [processTitle]="processTitle()">
        <img [src]="'confirmation-success.svg' | addStaticImagePath" alt="Erfolg" class="mx-auto mb-5" />
      </mwe-next-steps>
    </mwe-basic-card>
  } @else {
    <mwe-basic-card [hasBackground]="false" data-test="mwe-confirmation-view-success-no-info">
      <div class="d-flex flex-column align-items-center">
        <img src="/assets/img/success-animation_no_text.gif" alt="Success" class="mx-auto mb-5" style="max-width: 214px" />
        @if (successMsgKey()) {
          <h1 class="h4" [translate]="successMsgKey()"></h1>
        }
        @if (successSubtextKey()) {
          <span class="text--large text-center d-block" [translate]="successSubtextKey()"></span>
        }
      </div>
    </mwe-basic-card>
  }
}

<ng-template #stepsList let-steps="steps">
  @for (item of steps; track item; let last = $last) {
    @if (stepRenderer()) {
      <ng-container *ngComponentOutlet="stepRenderer(); inputs: { step: item.step, state: item.state }" />
    } @else {
      <div class="backend-process-step d-flex align-items-center" [ngClass]="{ 'mb-3': !last }">
        @if (getIconClassForStep(item)) {
          <i class="fas backend-process-step-icon mr-3" [ngClass]="getIconClassForStep(item)"></i>
        }
        <div class="backend-process-step-content">
          <span
            class="backend-process-step-title"
            [translate]="getTitleForStep(item)"
            [translateParams]="item.step.translationParams"
          ></span>
          @for (label of getLabelsForStep(item); track $index) {
            &nbsp;<span class="backend-process-step-label" [translate]="label" [translateParams]="item.step.translationParams"></span>
          }
        </div>
      </div>
    }
  }
</ng-template>
